import React from 'react';
import { OrderedMap } from 'immutable';
import classNames from 'classnames/bind';
import Switch from '@saucelabs/sl-component-switch';
import { Scrollbar } from '@saucelabs/sl-component-scrollbar';

import { Filter } from './FilterColumn';
import Styles from './FilterListSwitch.styles';

const context = classNames.bind(Styles);

export type FilterListSwitchProps = {
  filterCategory: string;
  filters: OrderedMap<string, Filter>;
  toggleItem: (key: string) => void;
};

const fallbackFilter: Filter = {
  active: true,
  disabled: false,
  greyedOut: false,
  label: '',
};

const FilterListSwitch: React.FC<FilterListSwitchProps> = ({
  filterCategory,
  filters,
  toggleItem,
}) => (
  <div className="h-full overflow-auto relative">
    <Scrollbar noScrollX>
      <ul className="list-none m-0 p-0">
        {/*
          // might look odd but since immutable 3.x types are crap
          // and don't really support the types in their data structures
          // we need to provide that fallback because TS assumes
          // filter could be undefined (which is never true)
        */}
        {filters.map(((filter = fallbackFilter, key) => {
          const uniqueKey = `${filterCategory}-${key as string}`;
          const { active, disabled, greyedOut, label } = filter;

          return (
            <li
              key={uniqueKey}
              aria-label={uniqueKey}
              className={context('filter-item', 'relative', 'font-normal', 'cursor-pointer',
                'border-0', 'border-t', 'border-solid', 'border-gray-200', 'last:border-b',
                {
                  'cursor-default': disabled,
                  'pointer-events-none': disabled,
                },
              )}
            >
              <label
                className={context(Styles.label, 'text-gray-600', {
                  'cursor-default': disabled,
                  'text-gray-disabled': greyedOut,
                })}
                htmlFor={uniqueKey}
              >
                {label || key}
                <div className={context(Styles['switch-wrapper'], { 'opacity-50': greyedOut })}>
                  <Switch
                    checked={active}
                    id={uniqueKey}
                    onChange={() => toggleItem(key as string)}
                    size={1.0}
                  />
                </div>
              </label>
            </li>
          );
        })).toArray()}
      </ul>
    </Scrollbar>
  </div>
);

export default FilterListSwitch;
